import React from 'react';
import CheckboxList from 'app/ui/form/CheckboxList/CheckboxList';
import './ConfirmAuthorRolesCheckboxList.scss';

export default function ConfirmAuthorRolesCheckboxList(props) {
    return <CheckboxList className="ConfirmAuthorRolesCheckboxList" {...props} />;
}
